import React from "react";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import styled from "styled-components";

const PriceBox = (props) => {
  const { home, choice, color } = props;

  const selected = home.selected;

  const BuyButton = (props) => {
    let link =
      props.product !== "smartPlus"
        ? "/apply/" + props.product
        : "/fontcare.php";
    let path = "https://www.fontbada.co.kr" + link;

    return props.count !== "0" ? (
      <a href={path} target="_new">
        <img src={`/assets/box_${props.product}.png`} />
      </a>
    ) : (
      <span>상담전용상품</span>
    );
  };

  const ChoiceList = Object.keys(choice).map((key, index) => (
    <Box key={index}>
      <BuyButton product={key} />
    </Box>
  ));

  return <Boxes>{ChoiceList}</Boxes>;
};

const Boxes = styled.div`
  display: flex;
  justify-content: flex-start;
  background-color: #fff;
  padding-bottom: 40px;
  gap: 35px;
`;

const Box = styled.div`
  background: #fff;
  margin-top: 10px;
  text-align: center;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 35px;
  &:hover {
    background: #ececec;
  }

  .title {
    font-family: HYGothicL, sans-serif;
    height: 60px;
    font-size: 26px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  .price {
    height: 110px;
    display: flex;
    line-height: 1.2;
    justify-content: center;
    align-items: flex-end;
    & {
      font-family: HY고딕B, sans-serif;
      font-size: large;
    }
    & span {
      font-size: large;
    }

    & .priceRow {
      display: flex;
      width: 140px;

      & .Year {
        font-family: HYGothicL, sans-serif;
        font-size: large;
        width: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        align-items: center;
      }

      & .Price {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 140px;
        & span {
          font-size: large;
        }
      }
    }

    & span {
      font-size: 12px;
    }
    & .callus {
      font-size: 18px;
    }
  }

  .desc {
    height: 90px;
    line-height: 1.8;
    font-family: HYGothicL, sans-serif;
    font-size: 16px;
    /*background-color:yellow;*/
    display: flex;
    justify-content: center;
    align-items: flex-end;
    white-space: pre-wrap;
  }

  .etc {
    font-family: HYGothicL, sans-serif;
    font-size: 10px;
    justify-content: center;
    color: #666;
  }

  .buyBtn {
    height: 114px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-family: HY고딕B, sans-serif;
      font-size: 21px;
    }
  }
`;

export default PriceBox;
